export default __webpack_public_path__ + "static/media/apollo-solar-logo.5740d7ca.png";